import { CXoneDigitalContact } from '@nice-devone/digital-sdk/src/lib/digital/contact/cxone-digital-contact';
import { MediaType } from './media-type';
import { CXoneContact } from '@nice-devone/agent-sdk';
import { CXonePopUrl } from '@nice-devone/common-sdk';
import { PopUrlService } from '../data/CXOne/services/pop-url.service';

export function isAniRedirect(value?: string | null) {
  return value && ['RESKILL', 'REAGENT'].includes(value.toUpperCase());
}

export function getMediaType(event: CXoneContact): MediaType {
  if (!event || !event.type) return 'unknown';

  if (event.type === 'voice') return 'voice';

  const channelType = (event as CXoneDigitalContact).channelType?.toLowerCase();
  return channelType as MediaType;
}

export function extractPopUrlMediaType(popUrl: CXonePopUrl) {
  if (!popUrl || !popUrl.url) return 'unknown';

  const deserialized = PopUrlService.deserializeScreenPopUrl(popUrl?.url);
  const type = deserialized?.['INTERACTIONTYPE'];
  if (!type || typeof type !== 'string') return 'unknown';

  switch (type.toLowerCase()) {
    case 'telefone':
      return 'voice';
    case 'chat':
      return 'chat';
    case 'whatsapp':
      return 'whatsapp';
    case 'email':
      return 'email';
    default:
      return 'unknown';
  }
}

export function isDigital(mediaType?: MediaType): boolean {
  return (
    !!mediaType &&
    ['chat', 'whatsapp', 'email'].includes(mediaType.toLowerCase())
  );
}

export function interactionTypeToMediaType(
  interactionType?: string | null,
): MediaType {
  if (!interactionType) return 'unknown';

  switch (interactionType.toLowerCase()) {
    case 'telefone':
      return 'voice';
    case 'chat':
      return 'chat';
    case 'whatsapp':
      return 'whatsapp';
    case 'email':
      return 'email';
    default:
      return 'unknown';
  }
}
